/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.30",
    versionName: "0.7.0-nightly.2026.9.30",
    versionChannel: "nightly",
    buildDate: "2026-09-30T00:18:44.652Z",
    commitHash: "7cad3d40c64cfee6f11ef77a843e010fefe7c8b3",
};
